var _g, _g2, _ellipse, _g3, _g4, _ellipse2, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTitle = function SvgTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 766,
    height: 104,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#title_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27B0DB",
    d: "M713.403 72.524c-4.62-27.72-29.356-36.575-41.147-37.537-11.79 0-31.618 5.342-16.603 26.71 15.015 21.367 44.757 16.121 57.75 10.827"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#title_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#title_svg__c)",
    d: "M739.835 20.173c-23.336-24.866-54.23-17.159-66.76-10.196-11.881 7.933-28.261 26.666 1.269 38.127 29.53 11.46 55.964-13.845 65.491-27.93"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.905,
    cy: 5.299,
    fill: "#89E6FF",
    opacity: 0.9,
    rx: 11.905,
    ry: 5.299,
    transform: "scale(-1 1)rotate(9.109 -394.424 -4409.38)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#title_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27B0DB",
    d: "M52.597 72.524c4.62-27.72 29.356-36.575 41.147-37.537 11.79 0 31.618 5.342 16.603 26.71-15.015 21.367-44.757 16.121-57.75 10.827"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#title_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#title_svg__f)",
    d: "M26.166 20.173C49.5-4.693 80.395 3.014 92.925 9.977c11.881 7.933 28.261 26.666-1.269 38.127-29.53 11.46-55.964-13.845-65.49-27.93"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.853,
    cy: 13.951,
    fill: "#89E6FF",
    opacity: 0.9,
    rx: 11.905,
    ry: 5.299,
    transform: "rotate(9.11 73.853 13.95)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#title_svg__g)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#title_svg__h)",
    d: "M88 26.667C88 11.939 99.94 0 114.667 0h536.666C666.061 0 678 11.94 678 26.667 678 56.122 654.122 80 624.667 80H141.333C111.878 80 88 56.122 88 26.667"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 4,
    d: "M90 26.667C90 13.044 101.044 2 114.667 2h536.666C664.956 2 676 13.044 676 26.667 676 55.017 653.017 78 624.667 78H141.333C112.983 78 90 55.017 90 26.667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "title_svg__a",
    width: 115.126,
    height: 94.21,
    x: 624.265,
    y: 8.999,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.994
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.36066 0 0 0 0 0.212153 0 0 0 0 0.783333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_247_707",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "title_svg__b",
    width: 134.113,
    height: 99.855,
    x: 631.709,
    y: -9.867,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.994
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.36066 0 0 0 0 0.212153 0 0 0 0 0.783333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_247_707",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "title_svg__d",
    width: 115.126,
    height: 94.21,
    x: 26.609,
    y: 8.999,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.994
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.36066 0 0 0 0 0.212153 0 0 0 0 0.783333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_247_707",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "title_svg__e",
    width: 134.113,
    height: 99.855,
    x: 0.178,
    y: -9.867,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.994
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.36066 0 0 0 0 0.212153 0 0 0 0 0.783333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_247_707",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "title_svg__g",
    width: 606,
    height: 96,
    x: 80,
    y: -5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.84 0 0 0 0 0.876857 0 0 0 0 0.9 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_247_707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_247_707",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20.02
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.521569 0 0 0 0 0.4 0 0 0 0 0.988235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "lighten",
    result: "effect2_innerShadow_247_707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title_svg__c",
    x1: 682.72,
    x2: 711.182,
    y1: 3.536,
    y2: 46.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A5D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "title_svg__f",
    x1: 83.28,
    x2: 54.818,
    y1: 3.536,
    y2: 46.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A5D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "title_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(113.564 0 0 106.912 382.655 40.337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B26EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B4EF8"
  })))));
};
export default SvgTitle;